export default class Gate{

    constructor(user){
        this.user = user;
    }
    loginUser(){
        return this.user;
    }
    isAdmin(){
        return this.user.type === 'admin';
    }
    isGov(){
        return this.user.type === 'gov';
    }
    isReg(){
        return this.user.type === 'reg';
    }
    isCeo(){
        return this.user.type === 'ceo';
    }
    isPrincipal(){
        return this.user.type === 'principal';
    }
    isTeacher(){
        return this.user.type === 'teacher';
    }
    isStudent(){
        return this.user.type === 'student';
    }
    isUser(){
        return this.user.type === 'user';
    }
    
    isAdminOrUser(){
        if(this.user.type === 'user' || this.user.type === 'admin'){
            return true;
        }
    }
    BaseUrl(){
        // return 'http://127.0.0.1:8000/';
        // return 'https://dev.obasi.tech/';
        // return 'https://www.obasitech.com/';
		  return 'https://www.dev.e2fe.com/'
    }
    BaseUrlWithoutSlash(){
        // return 'http://127.0.0.1:8000';
        // return 'https://dev.obasi.tech';
        // return 'https://www.obasitech.com';
		  return 'https://www.dev.e2fe.com'
    }
    
}

